<template>
  <v-dialog v-model="abierto" max-width="820" persistent scrollable>
    <v-card rounded="lg">
      <v-toolbar color="#194c9b" density="comfortable">
        <v-toolbar-title class="text-subtitle-1 font-weight-bold">
          Descargar Historia de Usuario — formato
        </v-toolbar-title>
        <v-spacer />
        <v-btn icon="mdi-close" variant="text" @click="cancelar"></v-btn>
      </v-toolbar>

      <v-tabs v-model="tab" color="#194c9b" density="comfortable">
        <v-tab value="portada">Portada / Marca</v-tab>
        <v-tab value="versiones">Control de versiones</v-tab>
        <v-tab value="cuerpo">Cuerpo (plantilla)</v-tab>
      </v-tabs>
      <v-divider />

      <v-card-text style="max-height: 62vh">
        <v-window v-model="tab">
          <!-- ===== PORTADA / MARCA ===== -->
          <v-window-item value="portada">
            <div class="text-body-2 text-medium-emphasis mb-3">
              El banner y el logo son personalizables (imágenes tuyas).
            </div>
            <v-row dense>
              <v-col cols="12" md="6">
                <v-file-input
                  :key="`banner-${fileKey}`"
                  label="Banner (portada y encabezado)"
                  accept="image/*"
                  variant="outlined"
                  density="compact"
                  prepend-icon="mdi-image"
                  hide-details
                  @update:model-value="(f) => cargarImagen(f, 'banner')"
                />
                <img v-if="cfg.banner" :src="cfg.banner" class="preview mt-2" />
              </v-col>
              <v-col cols="12" md="6">
                <v-file-input
                  :key="`logo-${fileKey}`"
                  label="Logo"
                  accept="image/*"
                  variant="outlined"
                  density="compact"
                  prepend-icon="mdi-image"
                  hide-details
                  @update:model-value="(f) => cargarImagen(f, 'logo')"
                />
                <img v-if="cfg.logo" :src="cfg.logo" class="preview mt-2" />
              </v-col>
            </v-row>
            <v-row dense class="mt-1">
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="cfg.coverTitle"
                  label="Título de portada"
                  variant="outlined"
                  density="compact"
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="cfg.headerTitle"
                  label="Título del encabezado"
                  variant="outlined"
                  density="compact"
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="6" class="mt-2">
                <v-text-field
                  v-model="cfg.version"
                  label="Versión"
                  variant="outlined"
                  density="compact"
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="6" class="mt-2">
                <v-text-field
                  v-model="cfg.headerColor"
                  label="Color de encabezado"
                  type="color"
                  variant="outlined"
                  density="compact"
                  hide-details
                />
              </v-col>
            </v-row>
          </v-window-item>

          <!-- ===== CONTROL DE VERSIONES ===== -->
          <v-window-item value="versiones">
            <div class="d-flex justify-space-between align-center mb-2">
              <div class="text-subtitle-2 font-weight-medium">Control de versiones</div>
              <v-btn size="small" variant="tonal" prepend-icon="mdi-plus" @click="agregarVersion">
                Fila
              </v-btn>
            </div>
            <v-table density="compact">
              <thead>
                <tr>
                  <th>Fecha</th><th>Versión</th><th>Elaboró</th><th>Descripción</th><th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(v, i) in cfg.versiones" :key="i">
                  <td><v-text-field v-model="v.fecha" density="compact" variant="plain" hide-details /></td>
                  <td><v-text-field v-model="v.version" density="compact" variant="plain" hide-details /></td>
                  <td><v-text-field v-model="v.elaboro" density="compact" variant="plain" hide-details /></td>
                  <td><v-text-field v-model="v.descripcion" density="compact" variant="plain" hide-details /></td>
                  <td>
                    <v-btn icon="mdi-close" size="x-small" variant="text" @click="cfg.versiones.splice(i, 1)" />
                  </td>
                </tr>
              </tbody>
            </v-table>
          </v-window-item>

          <!-- ===== CUERPO (plantilla) ===== -->
          <v-window-item value="cuerpo">
            <div class="text-body-2 text-medium-emphasis mb-2">
              Los <b>tokens</b> se reemplazan con los datos de la historia. Clic para insertar.
            </div>
            <div class="d-flex flex-wrap ga-2 mb-3">
              <v-chip
                v-for="t in tokens"
                :key="t.token"
                size="small"
                color="#194c9b"
                variant="tonal"
                @click="insertarToken(t.token)"
              >
                {{ t.token }} — {{ t.label }}
              </v-chip>
            </div>
            <v-textarea
              ref="tplRef"
              v-model="cfg.plantilla"
              label="Plantilla del cuerpo"
              variant="outlined"
              rows="10"
              auto-grow
              hide-details
              class="mono"
            />
            <v-btn size="small" variant="text" prepend-icon="mdi-restore" class="mt-2" @click="restaurar">
              Restaurar plantilla
            </v-btn>
          </v-window-item>
        </v-window>
      </v-card-text>

      <v-divider />
      <v-card-actions class="pa-3">
        <span class="text-caption text-medium-emphasis ml-2">{{ stories.length }} historia(s)</span>
        <v-spacer />
        <v-btn variant="text" @click="cancelar">Cancelar</v-btn>
        <v-btn
          color="#c1121f"
          variant="tonal"
          prepend-icon="mdi-file-pdf-box"
          :loading="generando === 'pdf'"
          :disabled="!stories.length"
          @click="descargarPDF"
        >
          PDF
        </v-btn>
        <v-btn
          color="#1883FF"
          variant="tonal"
          prepend-icon="mdi-file-word-box"
          :loading="generando === 'docx'"
          :disabled="!stories.length"
          @click="descargarWord"
        >
          Word
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { jsPDF } from "jspdf";
import {
  Document,
  Packer,
  Paragraph,
  TextRun,
  PageBreak,
  HeadingLevel,
  Table,
  TableRow,
  TableCell,
  WidthType,
  ImageRun,
  Header,
} from "docx";

const LS_KEY = "hu_export_config";
const PLANTILLA_DEFAULT = `{titulo}

Historia:
{historia}
`;
const CFG_DEFAULT = () => ({
  banner: "",
  logo: "",
  coverTitle: "Historias de Usuario",
  headerTitle: "Historia de Usuario",
  version: "Versión 1.0",
  headerColor: "#8FA8D8",
  versiones: [
    { fecha: "", version: "1.0", elaboro: "Equipo ITW", descripcion: "Elaboración de Historia de Usuario." },
  ],
  plantilla: PLANTILLA_DEFAULT,
});

export default {
  name: "HistoriaUsuarioExport",
  props: {
    modelValue: { type: Boolean, default: false },
    stories: { type: Array, default: () => [] }, // { title, summary, storyText }
    projectName: { type: String, default: "" },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      tab: "portada",
      generando: null,
      fileKey: 0,
      cfg: this.cargarCfg(),
      tokens: [
        { token: "{proyecto}", label: "Proyecto" },
        { token: "{titulo}", label: "Título" },
        { token: "{historia}", label: "Historia" },
      ],
    };
  },
  computed: {
    abierto: {
      get() {
        return this.modelValue;
      },
      set(v) {
        this.$emit("update:modelValue", v);
      },
    },
  },
  methods: {
    cargarCfg() {
      try {
        const saved = JSON.parse(localStorage.getItem(LS_KEY));
        // banner y logo nunca se restauran del guardado: siempre inician vacíos.
        return { ...CFG_DEFAULT(), ...(saved || {}), banner: "", logo: "" };
      } catch {
        return CFG_DEFAULT();
      }
    },
    guardarCfg() {
      // No persistimos banner ni logo para que no se queden cargados en siguientes aperturas.
      localStorage.setItem(LS_KEY, JSON.stringify({ ...this.cfg, banner: "", logo: "" }));
    },
    restaurar() {
      this.cfg.plantilla = PLANTILLA_DEFAULT;
    },
    cancelar() {
      // Limpia banner y logo para que no se queden cargados al reabrir el diálogo.
      this.cfg.banner = "";
      this.cfg.logo = "";
      this.fileKey++; // fuerza re-render de los v-file-input para vaciar el archivo seleccionado
      this.abierto = false;
    },
    agregarVersion() {
      this.cfg.versiones.push({ fecha: "", version: "", elaboro: "", descripcion: "" });
    },
    async cargarImagen(file, tipo) {
      const f = Array.isArray(file) ? file[0] : file;
      if (!f) return;
      this.cfg[tipo] = await this.fileToDataUrl(f);
    },
    fileToDataUrl(file) {
      return new Promise((resolve, reject) => {
        const r = new FileReader();
        r.onload = () => resolve(r.result);
        r.onerror = reject;
        r.readAsDataURL(file);
      });
    },
    fmtImg(dataUrl) {
      if (dataUrl && dataUrl.startsWith("data:image/png")) return "PNG";
      return "JPEG";
    },
    hexToRgb(hex) {
      const h = String(hex || "").replace("#", "");
      const n = h.length === 3 ? h.split("").map((c) => c + c).join("") : h;
      const int = parseInt(n || "8fa8d8", 16);
      return [(int >> 16) & 255, (int >> 8) & 255, int & 255];
    },
    // docx v9 exige "type" en ImageRun (png/jpg/gif/bmp).
    docxImgType(dataUrl) {
      if (dataUrl && dataUrl.startsWith("data:image/png")) return "png";
      if (dataUrl && dataUrl.startsWith("data:image/gif")) return "gif";
      return "jpg";
    },
    dataUrlToU8(dataUrl) {
      const b64 = dataUrl.split(",")[1] || "";
      const bin = atob(b64);
      const arr = new Uint8Array(bin.length);
      for (let i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
      return arr;
    },
    insertarToken(token) {
      const el = this.$refs.tplRef?.$el?.querySelector("textarea");
      if (el && typeof el.selectionStart === "number") {
        const s = el.selectionStart;
        const e = el.selectionEnd;
        this.cfg.plantilla =
          this.cfg.plantilla.slice(0, s) + token + this.cfg.plantilla.slice(e);
        this.$nextTick(() => {
          el.focus();
          const p = s + token.length;
          el.setSelectionRange(p, p);
        });
      } else {
        this.cfg.plantilla += token;
      }
    },
    // Reemplaza los ">" de inicio de línea (blockquote de markdown) por "-" como viñeta.
   
    render(us) {
      const map = {
        "{proyecto}": this.projectName || "",
        "{titulo}": us.title || "",
        "{historia}": us.storyText || ""
      
      };
      return this.cfg.plantilla.replace(
        /\{proyecto\}|\{titulo\}|\{historia\}/g,
        (m) => map[m] ?? m,
      );
    },
    nombreArchivo(ext) {
      const base =
        this.stories.length === 1
          ? `HistoriaUsuario_${this.projectName}_${this.stories[0].title || ""}`
          : `HistoriasUsuario_${this.projectName}`;
      return base.replace(/[\\/:*?"<>|]/g, "_").slice(0, 120) + "." + ext;
    },
    descargarBlob(blob, filename) {
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    },

    // ---------------- PDF (jsPDF) ----------------
    async descargarPDF() {
      this.generando = "pdf";
      try {
        this.guardarCfg();
        const doc = new jsPDF({ unit: "pt", format: "a4" });
        const W = doc.internal.pageSize.getWidth();
        const H = doc.internal.pageSize.getHeight();
        const M = 40;

        // PORTADA
        if (this.cfg.banner) {
          doc.addImage(this.cfg.banner, this.fmtImg(this.cfg.banner), 0, 0, W, 210);
        }
        doc.setFont("helvetica", "bold");
        doc.setFontSize(30);
        doc.setTextColor(30);
        doc.text(this.cfg.coverTitle || "", W / 2, H * 0.45, { align: "center" });
        if (this.cfg.logo) {
          const lw = 200, lh = 130;
          doc.addImage(this.cfg.logo, this.fmtImg(this.cfg.logo), W / 2 - lw / 2, H * 0.5, lw, lh);
        }

        const header = () => {
          doc.setFillColor(...this.hexToRgb(this.cfg.headerColor));
          doc.rect(M, 30, W - 2 * M, 55, "F");
          if (this.cfg.logo) {
            doc.addImage(this.cfg.logo, this.fmtImg(this.cfg.logo), M + 8, 34, 46, 46);
          }
          doc.setFont("helvetica", "bold");
          doc.setFontSize(14);
          doc.setTextColor(255);
          doc.text(this.cfg.headerTitle || "", W - M - 10, 62, { align: "right" });
          doc.setTextColor(60);
          doc.setFontSize(10);
          doc.text(this.cfg.version || "", W - M - 10, 102, { align: "right" });
        };

        // CONTROL DE VERSIONES
        doc.addPage();
        header();
        doc.setFont("helvetica", "bold");
        doc.setFontSize(14);
        doc.setTextColor(40);
        doc.text("Control de Versiones", W / 2, 130, { align: "center" });
        this.tablaVersionesPDF(doc, M, 150, W - 2 * M);

        // CUERPO
        this.stories.forEach((us) => {
          doc.addPage();
          header();
          doc.setFont("helvetica", "normal");
          doc.setFontSize(11);
          doc.setTextColor(20);
          const maxW = W - 2 * M;
          const lineH = 15;
          const lineas = doc.splitTextToSize(this.render(us), maxW);
          let y = 110;
          for (const linea of lineas) {
            if (y > H - M) {
              doc.addPage();
              header();
              y = 110;
            }
            doc.text(linea, M, y);
            y += lineH;
          }
        });

        doc.save(this.nombreArchivo("pdf"));
      } catch (e) {
        console.error("Error generando PDF", e);
      } finally {
        this.generando = null;
      }
    },
    tablaVersionesPDF(doc, x, y, w) {
      const cols = [
        { key: "fecha", label: "Fecha", frac: 0.2 },
        { key: "version", label: "Versión", frac: 0.15 },
        { key: "elaboro", label: "Elaboró", frac: 0.3 },
        { key: "descripcion", label: "Descripción", frac: 0.35 },
      ];
      const rowH = 26;
      // header
      doc.setFillColor(...this.hexToRgb(this.cfg.headerColor));
      doc.rect(x, y, w, rowH, "F");
      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      doc.setTextColor(20);
      let cx = x;
      cols.forEach((c) => {
        const cw = w * c.frac;
        doc.text(c.label, cx + cw / 2, y + 17, { align: "center" });
        cx += cw;
      });
      // rows
      doc.setFont("helvetica", "normal");
      let ry = y + rowH;
      this.cfg.versiones.forEach((v) => {
        cx = x;
        doc.setDrawColor(200);
        cols.forEach((c) => {
          const cw = w * c.frac;
          doc.rect(cx, ry, cw, rowH);
          const txt = doc.splitTextToSize(String(v[c.key] ?? ""), cw - 8);
          doc.text(txt, cx + cw / 2, ry + 16, { align: "center" });
          cx += cw;
        });
        ry += rowH;
      });
    },

    // ---------------- Word (docx) ----------------
    async descargarWord() {
      this.generando = "docx";
      try {
        this.guardarCfg();
        const children = [];

        // PORTADA
        if (this.cfg.banner) {
          children.push(
            new Paragraph({
              children: [
                new ImageRun({
                  type: this.docxImgType(this.cfg.banner),
                  data: this.dataUrlToU8(this.cfg.banner),
                  transformation: { width: 520, height: 180 },
                }),
              ],
            }),
          );
        }
        children.push(
          new Paragraph({
            heading: HeadingLevel.TITLE,
            alignment: "center",
            spacing: { before: 2000, after: 400 },
            children: [new TextRun({ text: this.cfg.coverTitle || "", bold: true, size: 56 })],
          }),
        );
        if (this.cfg.logo) {
          children.push(
            new Paragraph({
              alignment: "center",
              children: [
                new ImageRun({
                  type: this.docxImgType(this.cfg.logo),
                  data: this.dataUrlToU8(this.cfg.logo),
                  transformation: { width: 220, height: 140 },
                }),
              ],
            }),
          );
        }
        children.push(new Paragraph({ children: [new PageBreak()] }));

        // CONTROL DE VERSIONES
        children.push(
          new Paragraph({
            alignment: "center",
            spacing: { after: 200 },
            children: [new TextRun({ text: "Control de Versiones", bold: true, size: 28 })],
          }),
        );
        children.push(this.tablaVersionesDocx());
        children.push(new Paragraph({ children: [new PageBreak()] }));

        // CUERPO
        this.stories.forEach((us, idx) => {
          if (idx > 0) children.push(new Paragraph({ children: [new PageBreak()] }));
          this.render(us)
            .split("\n")
            .forEach((linea) => {
              children.push(new Paragraph({ children: [new TextRun(linea)] }));
            });
        });

        const doc = new Document({
          sections: [
            {
              headers: { default: this.headerDocx() },
              children,
            },
          ],
        });
        const blob = await Packer.toBlob(doc);
        this.descargarBlob(blob, this.nombreArchivo("docx"));
      } catch (e) {
        console.error("Error generando Word", e);
      } finally {
        this.generando = null;
      }
    },
    headerDocx() {
      const runs = [];
      if (this.cfg.logo) {
        runs.push(
          new ImageRun({
            type: this.docxImgType(this.cfg.logo),
            data: this.dataUrlToU8(this.cfg.logo),
            transformation: { width: 36, height: 36 },
          }),
        );
        runs.push(new TextRun({ text: "   " }));
      }
      runs.push(
        new TextRun({ text: this.cfg.headerTitle || "", bold: true }),
        new TextRun({ text: `    ${this.cfg.version || ""}`, size: 18 }),
      );
      return new Header({ children: [new Paragraph({ children: runs })] });
    },
    tablaVersionesDocx() {
      const celda = (text, opts = {}) =>
        new TableCell({
          shading: opts.header
            ? { fill: String(this.cfg.headerColor || "#8FA8D8").replace("#", "") }
            : undefined,
          children: [
            new Paragraph({
              alignment: "center",
              children: [new TextRun({ text: String(text ?? ""), bold: !!opts.header })],
            }),
          ],
        });
      const rows = [
        new TableRow({
          children: [
            celda("Fecha", { header: true }),
            celda("Versión", { header: true }),
            celda("Elaboró", { header: true }),
            celda("Descripción", { header: true }),
          ],
        }),
        ...this.cfg.versiones.map(
          (v) =>
            new TableRow({
              children: [celda(v.fecha), celda(v.version), celda(v.elaboro), celda(v.descripcion)],
            }),
        ),
      ];
      return new Table({ width: { size: 100, type: WidthType.PERCENTAGE }, rows });
    },
  },
};
</script>

<style scoped>
.mono :deep(textarea) {
  font-family: "Courier New", monospace;
  font-size: 13px;
  line-height: 1.5;
}
.preview {
  max-height: 90px;
  max-width: 100%;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
}
</style>
